import { Endpoint } from 'app/services/i-http-service';
import { ApplicationFile } from './application-file.entity';

@Endpoint('applications/involved/signature/:linkedId')
export class ApplicationInvolvedSignature extends ApplicationFile {
  fileSyncKey: string;
}
